export default __webpack_public_path__ + "static/media/TezerionLogo.3f35889c.svg";